import { Flex } from '@aloft/toolkit-sui';

import { PropertyGridColumnDefinition } from '../../types.ts';
import { PopoverOptionRow } from './PopoverOptionRow.tsx';
import { SourceOption } from './types.ts';

type PopoverOptionsListProps = {
  options: SourceOption[];
  propertyData?: PropertyGridColumnDefinition['propertyData'];
  onSelect: (option: SourceOption) => void;
};

export const PopoverOptionsList = ({
  options,
  propertyData,
  onSelect,
}: PopoverOptionsListProps) => (
  <Flex flexDirection="column" gap="1px" maxHeight="25vh" overflowY="auto">
    {options.map((option) => (
      <PopoverOptionRow
        key={option.source}
        value={option.value}
        source={option.source}
        propertyData={propertyData}
        onClick={() => onSelect(option)}
      />
    ))}
  </Flex>
);
